import React from 'react'

export const LoremIpsum = ({background}) => {
  return (
    <p style={{ background}}>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Expedita aspernatur cum possimus esse fuga placeat
        quod error, dolorum inventore iste ipsum perferendis. Facilis, dignissimos quis. Expedita numquam sapiente ea
        dolor, impedit molestiae placeat facere non dolorem tenetur dignissimos illum atque amet magni officiis nulla,
        esse architecto, nisi ipsam exercitationem voluptatibus hic quia? Quis inventore recusandae consequuntur
        accusamus a velit, consectetur aliquam iusto assumenda quia eos qui temporibus molestias eius minima consequatur
        veniam nam odio cum ipsam neque fugit deserunt laudantium rem. Expedita exercitationem veritatis in, maiores
        dignissimos nostrum fuga ipsam laborum dolorem, qui minima modi eveniet sunt. Voluptatibus cum quidem totam
        dolorum excepturi! Tenetur vero aut possimus optio impedit dolore est veniam fugit saepe quidem eius omnis ad at
        distinctio neque voluptates numquam nisi, alias tempore obcaecati libero? Dolore, vel harum ipsam quod
        reiciendis facere sed asperiores fuga. Iure explicabo eaque provident a? Cumque vel eveniet sit rem voluptatibus
        minima, eos eaque totam aut explicabo unde, nesciunt incidunt earum deleniti ipsa sapiente, nihil eum
        reprehenderit rerum repudiandae autem deserunt. Eius repellendus quo reprehenderit ratione ea, totam qui
        asperiores eum delectus incidunt officiis voluptatum eaque error ex voluptatem ab, optio eveniet. Est sapiente
        incidunt temporibus, sed dignissimos voluptate error impedit vel!
  </p>
  )
}
